import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Bell, BellOff, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, currentSubscription, enablePush, disablePush } from "@/lib/push";

// Compact enable/disable button for browser push notifications.
export function PushBell() {
  const [supported] = useState(() => pushSupported());
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supported) return;
    currentSubscription().then((s) => setOn(!!s && Notification.permission === "granted"));
  }, [supported]);

  if (!supported) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (on) { await disablePush(); setOn(false); toast.message("Notifications turned off"); }
      else { await enablePush(); setOn(true); toast.success("Notifications on — you'll be alerted about dispatches"); }
    } catch (e) {
      const msg = String(e?.message || "");
      if (msg.startsWith("permission-")) toast.error("Allow notifications in your browser settings to enable alerts");
      else toast.error(msg || "Could not update notifications");
    } finally { setBusy(false); }
  };

  return (
    <Button onClick={toggle} disabled={busy} size="sm" variant={on ? "outline" : "default"} data-testid="push-bell-toggle"
      className="h-9 gap-1.5 text-sm">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : on ? <BellRing className="h-4 w-4" /> : <Bell className="h-4 w-4" />}
      {on ? "Alerts on" : "Enable alerts"}
    </Button>
  );
}
